import AddressPredictionsCmp from '@porterin/booking-flow/src/order-review/view/components/AddressPredictionsCmp';
import EmptyPredictionsCmp from '@porterin/booking-flow/src/order-review/view/components/EmptyPredictionsCmp';
import React from 'react';

export interface AddressPredictionsViewCmpProps {
  predictions: google.maps.places.AutocompletePrediction[];
  on_prediction_click: (
    prediction: google.maps.places.AutocompletePrediction,
  ) => void;
}

const AddressPredictionsViewCmp: React.FC<AddressPredictionsViewCmpProps> = ({
  predictions,
  on_prediction_click,
}) => {
  return predictions?.length === 0 ? (
    <EmptyPredictionsCmp />
  ) : (
    <AddressPredictionsCmp
      predictions={predictions}
      on_prediction_click={on_prediction_click}
    />
  );
};

export default AddressPredictionsViewCmp;
